import axios from 'axios';

export function getHistoricRatesBetweenCurrencies(data, cancelToken) {
  const query = new URLSearchParams({ ...data, access_key: process.env.REACT_APP_FOREX_KEY }).toString();

  return axios.get(`https://api.exchangeratesapi.io/v1/timeseries?${query}`, { cancelToken });
}
